import {  get } from "../../service/api";

const GetTodayInvoices = async (merchantId) => {
    try {
        const response = await get(`/dashboard/last7?merchantId=${merchantId}`);
        return response.data;
    } catch (error) {
        console.error('Error GetTodayInvoices:', error);
        throw error;
    }
};

export default GetTodayInvoices;